import * as React from 'react';

const Package = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={14} height={14} viewBox="0 0 23 23" {...props}>
        <path
            fill="currentColor"
            d="M15.973 8.271a.25.25 0 0 0 0-.455L6.216 3.368a.5.5 0 0 0-.406 0L1.993 5.024a.25.25 0 0 0 0 .46l10.29 4.288a.5.5 0 0 0 .4-.006zM22.062 5.5a.25.25 0 0 0 0-.456L12.4.847a1 1 0 0 0-.8 0l-3.22 1.4a.25.25 0 0 0 0 .457l9.7 4.422a.5.5 0 0 0 .414 0zM.846 6.63a.25.25 0 0 0-.346.231v11.146a1 1 0 0 0 .615.923L11.4 23.217a.25.25 0 0 0 .346-.231V11.34a.25.25 0 0 0-.154-.231zM13.25 22.944a.25.25 0 0 0 .353.228l9.311-4.232a1 1 0 0 0 .586-.91V6.886a.25.25 0 0 0-.353-.228L13.4 11.09a.25.25 0 0 0-.147.227z"
        />
    </svg>
);
export default Package;
